import { SxProps, Theme } from '@mui/material/styles';
import { t } from 'i18next';
import { omit } from 'lodash-es';

import {
  SmallButton,
  SmallLoadingButton,
} from '~components/Order/ordersDispatchStyledComponents';

import Dialog from './Dialog';
import DialogActions from './DialogActions';
import DialogContent from './DialogContent';
import DialogHeader from './DialogHeader';

export interface ConfirmationDialogProps {
  cancelButtonProps?: React.ComponentProps<typeof SmallButton>;
  confirmButtonProps?: React.ComponentProps<typeof SmallLoadingButton>;
  isBusy?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  sx?: SxProps<Theme>;
  title?: React.ReactNode;
}

export default function ConfirmationDialog({
  cancelButtonProps,
  confirmButtonProps,
  children,
  isBusy,
  isOpen,
  onClose,
  onConfirm,
  sx,
  title,
}: React.PropsWithChildren<ConfirmationDialogProps>) {
  return (
    <Dialog isOpen={isOpen} maxWidth="sm" onClose={onClose} sx={sx}>
      {title ? <DialogHeader onClose={onClose}>{title}</DialogHeader> : null}

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <SmallButton
          variant="outlined"
          color="secondary"
          disabled={isBusy}
          onClick={onClose}
          {...omit(cancelButtonProps, 'children')}
        >
          {cancelButtonProps?.children || t('actions.cancel')}
        </SmallButton>

        <SmallLoadingButton
          color="brandV2Red"
          loading={isBusy}
          onClick={onConfirm}
          variant="contained"
          {...omit(confirmButtonProps, 'children')}
        >
          {confirmButtonProps?.children || t('actions.confirm')}
        </SmallLoadingButton>
      </DialogActions>
    </Dialog>
  );
}
